export enum HubsViewMode {
  Regions = 'Regions',
  Flat = 'Flat',
  Hidden = 'Hidden',
  Around = 'Around',
}

export enum HubsCycleType {
  Base = 'Base',
  Short = 'Short',
  Extended = 'Extended',
}
